import createIcon from '../../createIcon';

/**
 * @component @name Functions
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNEg2VjZMMTIuNSAxMkw2IDE4VjIwSDE4VjE3SDExTDE2IDEyTDExIDdIMThWNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Functions = createIcon('Functions', [
  ['path', { d: 'M18 4H6V6L12.5 12L6 18V20H18V17H11L16 12L11 7H18V4Z', key: 'ziigy1' }],
]);

export default Functions;
